exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".showbox[data-v-26975bc4] {\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-width: 80%;\n}\n.showbox .font-12[data-v-26975bc4] {\n  overflow: hidden;\n}\n[data-v-26975bc4] .el-form-item {\n  margin-bottom: 4px;\n}\n.show-url[data-v-26975bc4] {\n  padding: 20px 0 0;\n}\n.show-url span[data-v-26975bc4] {\n  display: inline-block;\n  padding-right: 10px;\n}\n", ""]);

// exports
